import React from 'react'
import Header from '../components/cms/header'
import Footer from '../components/cms/footer'
import { getMenu, Menu } from '../utils/menus'
import Layout from '../components/layout'
import Toolbar from '../components/toolbar'
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import { IconRemoveFromCart, IconArrow, IconCartCheck } from '../components/icons'
import Renderer from '../components/form/richEditorRenderer'
import { useState, useEffect } from 'react'
import { Check, getChecksById } from '../utils/checks'
import Link from 'next/link'
import { getToken } from '../utils/auth'
import { More } from '../components/check/checkSellTable'
import Strings from '../components/strings'

interface Props {
  headerMenu: Menu[]
  footerMenu: Menu[]
  token?: string
}

const Cart = ({ headerMenu, footerMenu, token }) => {
  const [cart, setCart] = useState<Check[]>([])
  const [refresh, setRefresh] = useState(false)

  const doRefresh = () => setRefresh(!refresh)

  useEffect(() => {
    const ids = JSON.parse(localStorage.getItem('cart') || JSON.stringify([]))

    getChecksById(ids).then(checks => {
      setCart(checks)
    })
  }, [refresh])

  const removeFromCart = (tmpId: string) => {
    localStorage.setItem('cart', JSON.stringify(cart.filter(({ id }) => id !== tmpId).map(({ id }) => id)))
    doRefresh()
  }

  return (
    <div className="landingPage">
      <Header headerMenu={headerMenu} token={token} />
      <Layout>
        <h1 className="text-align=c mt=2 mb=6">{Strings.de.pages.signup.cart}</h1>
        <Toolbar>
          <div className="p=2 py=3 flex w=full align-center cm--toolbar-cart">
            <div className="mr=2 flex align-center">
              {Strings.de.pages.signup.cart} <IconCartCheck className="mx=1 disabled" />
            </div>
            <div className="mr=2 flex align-center">
              {Strings.de.pages.signup.data} <IconCartCheck className="mx=1 disabled" />
            </div>
            <div className="ml flex align-center">
              {Strings.de.pages.signup.completed} <IconCartCheck className="mx=1 disabled" />
            </div>
          </div>
        </Toolbar>
        <div className="table__container mb=3 r elevated c=text">
          {!!cart.length && (
            <Table classes={{ root: 'c=text table' }}>
              <TableHead>
                <TableRow>
                  <TableCell>{Strings.de.components.check.typeShort}</TableCell>
                  <TableCell>{Strings.de.components.check.name}</TableCell>
                  <TableCell></TableCell>
                  <TableCell className="sticky right c=text text-align=c">
                    {Strings.de.components.table.delete}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="table__body">
                {!!cart.length &&
                  cart.map(check => {
                    if (!check) {
                      return
                    }

                    const { id, title, norm, description, valid, pdfLabels } = check

                    if (!valid) {
                      return
                    }

                    const inCart = !!cart.filter(({ id }) => id === check.id).length

                    return (
                      <TableRow key={id}>
                        <TableCell>{pdfLabels.title}</TableCell>
                        <TableCell>{title}</TableCell>
                        <TableCell>
                          <More check={check} />
                        </TableCell>
                        <TableCell className="sticky right c=text text-align=c">
                          <IconRemoveFromCart className="c=prim-alt pointer" onClick={() => removeFromCart(id)} />
                        </TableCell>
                      </TableRow>
                    )
                  })}
              </TableBody>
            </Table>
          )}
          {!cart.length && <h2 className="text-align=c my=6">{Strings.de.pages.signup.emptyCart}</h2>}
          {!!cart.length && (
            <div className="flex justify-center px=4 py=3">
              <Link href="/signup">
                <a className="c=prim p=2 r-circle cm--btn-primary">
                  {Strings.de.pages.signup.continue} <IconArrow className="ml=1" />
                </a>
              </Link>
            </div>
          )}
        </div>
      </Layout>
      <Footer headerMenu={headerMenu} footerMenu={footerMenu} />
    </div>
  )
}

Cart.getInitialProps = async ctx => {
  const headerMenu = await getMenu('header')
  const footerMenu = await getMenu('footer')
  const token = getToken(ctx)

  return {
    headerMenu,
    footerMenu,
    token,
  } as Props
}

export default Cart
